import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'external-link-icon',
  templateUrl: './external-link-icon.component.html',
  styles: [':host { line-height: 0; }'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class ExternalLinkIconComponent {}
